<button mat-raised-button color="primary" (click)="getLocation()">
  {{buttonText}}
</button>
<br/>
<div>{{position}}</div>
<div [id]="id" [hidden]="hidden" class="geocode-id-div margin-b_one"></div>
